import { createContext } from "react";

export interface PageHeaderMeta {
  title: string;
  subtitle?: string;
  /** Hebt Titel und Untertitel hervor, z. B. bei einer Stromstörung. */
  tone?: "danger" | "warning";
  /** Globale Suche: Treffer ohne Seitenwechsel (z. B. Dashboard) */
  onSelectGuest?: (guestId: string) => void;
  onSelectBooking?: (bookingId: string) => void;
}

interface PageHeaderContextValue {
  meta: PageHeaderMeta | null;
  setPageMeta: (m: PageHeaderMeta | null) => void;
}

export const PageHeaderContext = createContext<PageHeaderContextValue | null>(null);
